import * as React from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { useState, ReactNode } from "react";
import { Form, DatePicker, Button, Tooltip } from "antd";
import { getRangePickerValue } from "../Input/DatePickerExtensions";
import { RangePickerValue } from "antd/lib/date-picker/interface";

export interface SearchParameters {
  from: Date;
  to: Date;
}

interface Props extends WrappedComponentProps {
  onSearch: (searchParameters: SearchParameters) => void;

  from?: Date;
  onFromChange?: (from: Date | undefined) => void;

  to?: Date;
  onToChange?: (to: Date | undefined) => void;

  extra?: string|ReactNode;
}

function TradeHistorySearchFormCmp(props: Props) {
  const [from, setFrom] = useState(props.from);
  const [to, setTo] = useState(props.to);

  const onDateChange = (dates: RangePickerValue) => {
    const pickerFrom = dates[0];
    const selectedFrom = pickerFrom?.startOf("date").toDate();
    setFrom(selectedFrom);
    if (props.onFromChange !== undefined) {
      props.onFromChange(selectedFrom);
    }

    const pickerTo = dates[1];
    const selectedTo = pickerTo?.endOf("date").toDate();
    setTo(selectedTo);
    if (props.onToChange !== undefined) {
      props.onToChange(selectedTo);
    }
  };

  const onSearchClick = () => {
    props.onSearch({
      from: from!,
      to: to!
    });
  }

  const canSearch = from !== undefined && to !== undefined;
  const searchButton = (
    <Button
      type="primary"
      icon="search"
      disabled={!canSearch}
      onClick={() => onSearchClick()}
    >
      {props.intl.formatMessage({ id: "tradeHistorySearchForm.search" })}
    </Button>
  );

  return (
    <Form layout="inline">
      <Form.Item label={props.intl.formatMessage({ id: "tradeHistorySearchForm.date" })}>
        <DatePicker.RangePicker
          showTime={false}
          allowClear
          placeholder={[props.intl.formatMessage({ id: "tradeHistorySearchForm.from" }), props.intl.formatMessage({ id: "statementsSearchFrom.to" })]}
          disabledDate={x => (x === null || x === undefined) || x.toDate() > new Date()}
          onChange={dates => onDateChange(dates)}
          value={getRangePickerValue(from, to)}
        />
      </Form.Item>
      <Form.Item>
        {canSearch
          ? searchButton
          : <Tooltip title={props.intl.formatMessage({ id: "tradeHistorySearchForm.fromAndToDatesRequiredValidationMessage" })}>{searchButton}</Tooltip>
        }
      </Form.Item>
      {
        props.extra
          ? <Form.Item style={{ float: "right" }}>{props.extra}</Form.Item>
          : ""
      }
    </Form>
  );
}

export const TradeHistorySearchForm = injectIntl(TradeHistorySearchFormCmp);
